import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import typo_ligne_couleur_001_2x from '../assets/images/typo_ligne_couleur_001@2x.png';
import logo_couleur_bleu_2x from '../assets/images/logo_couleur_bleu@2x.png';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsMenuOpen(false);
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (
        isMenuOpen &&
        menuRef.current && !menuRef.current.contains(e.target as Node) &&
        buttonRef.current && !buttonRef.current.contains(e.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto flex justify-between items-center h-20 px-4 sm:px-6 lg:px-8">
        {/* Logo et Titre */}
        <Link to="/" className="flex items-center gap-0 flex-shrink-0">
          <img 
            src={logo_couleur_bleu_2x} 
            alt="VanLife Logo" 
            className="h-12 w-auto sm:h-14 md:h-16"
          />
          <img 
            src={typo_ligne_couleur_001_2x} 
            alt="VanLife Titre" 
            className="h-16 w-auto sm:h-18 md:h-20 -ml-4 sm:-ml-5 md:-ml-6"
          />
        </Link>

        {/* Navigation Desktop et Bouton Réserver */}
        <div style={{ fontFamily: 'Quicksand, sans-serif' }} className="hidden md:flex items-center space-x-1 font-bold flex-shrink-0">
            <Link
              to="/"
              className="text-gray-700 hover:text-blue-500 px-3 py-2 transition-colors"
            >
              Accueil
            </Link>
            <Link
              to="/van-life"
              className="text-gray-700 hover:text-blue-500 px-3 py-2 transition-colors"
            >
              Van Life
            </Link>
            <Link
              to="/faq"
              className="text-gray-700 hover:text-blue-500 px-3 py-2 transition-colors"
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-blue-500 px-3 py-2 transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/reserver"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md ml-4"
            >
              Nos véhicules
            </Link>
          </div>

          {/* Menu Mobile Button */}
          <div className="md:hidden flex-shrink-0">
            <button
              ref={buttonRef}
              onClick={toggleMenu}
              className="text-gray-700 hover:text-blue-500 focus:outline-none focus:text-blue-500 p-2"
              aria-label="Menu"
              aria-expanded={isMenuOpen}
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

      {/* Menu Mobile */}
      {isMenuOpen && (
        <div ref={menuRef} className="md:hidden px-4">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100" style={{ fontFamily: 'Quicksand, sans-serif' }}>
              <Link 
                to="/" 
                className="block text-gray-700 hover:text-blue-500 px-3 py-2 text-base font-bold transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link 
                to="/van-life" 
                className="block text-gray-700 hover:text-blue-500 px-3 py-2 text-base font-bold transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Van Life
              </Link>
              <Link
                to="/faq"
                className="block text-gray-700 hover:text-blue-500 px-3 py-2 text-base font-bold transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link
                to="/contact"
                className="block text-gray-700 hover:text-blue-500 px-3 py-2 text-base font-bold transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <div className="pt-2">
                <Link
                  to="/reserver"
                  className="block bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg text-base font-bold transition-colors duration-200 text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Nos véhicules
                </Link>
              </div>
            </div>
        </div>
      )}
    </header>
  );
};

export default Header;